module.exports = __webpack_public_path__ + "img/Howard.5e1f6ac8.jpg";